import { InjectionToken } from '@angular/core';
import { AreaOfUse } from '../../../core/model';
import { Occ } from '../../../core/occ/occ-models';
import { Converter } from '../../../core/util/converter.service';

export const AREA_OF_USE_CATEGORY_NORMALIZER = new InjectionToken<Converter<Occ.AreaOfUse, AreaOfUse>>(
  'AreaOfUseCategoryNormalizer'
);
